app.service('RecordViewService', ['basePluginService', '$q',
    function (basePluginService,$q) {
        angular.extend(this, basePluginService);

        var service = {};

        service.getRecordViewData = function (paginationModel, portletId) {
            return basePluginService.backend.post("recordView", paginationModel, portletId);
        };     
        
        return service;

    }]);